<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="certificationBodies"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalCertificationBodies"
                  :loading="certificationBodiesLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-license
          </v-icon>
          Virtual Learning Environment CMS: Awarding Bodies
        </v-card-title>

        <v-card-title class="mb-10">

          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add an Awarding Body
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Awarding Bodies"
              filled
              rounded
              single-line
              hide-details
              placeholder="Search awarding bodies"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.tags="{ item }">
        <TagsDisplay :items="item.tags"/>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn
            x-small
            depressed
            @click="deleteItem(item)"
            class="pa-3 ma-1">
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

    </v-data-table>

    <CertificationBodyAdd/>
    <CertificationBodyEdit/>
    <CertificationBodyDelete/>


  </v-card>
</template>

<script>

import { mapActions, mapGetters, mapState } from "vuex";
import CertificationBodyAdd from "@/components/CertificationBodies/CertificationBodyAdd";
import CertificationBodyEdit from "@/components/CertificationBodies/CertificationBodyEdit";
import CertificationBodyDelete from "@/components/CertificationBodies/CertificationBodyDelete";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";
import TagsDisplay from "@/components/common/TagsDisplay";

export default {
  name: "CertificationBodies",
  components: {
    TagsDisplay, RefreshTableHeader, RefreshTableFooter, CertificationBodyAdd,
    CertificationBodyEdit, CertificationBodyDelete,
  },
  computed: {
    ...mapState([
      'certificationBodiesLoading', 'totalCertificationBodies', 'certificationBodiesQueryParams',
    ]),
    ...mapGetters([
      'certificationBodies', 'certificationBodiesLoading', 'totalCertificationBodies',
      'currentCertificationBodyItem', 'dataTableFooterProps', 'certificationBodiesQueryParams',
    ]),
  },
  methods: {
    ...mapActions([
      'getCertificationBodies', 'getCertificationBody', 'clearCertificationBodyApiError',
      'setOpenDialog', 'setCertificationBodyPaginationOptions', 'setCertificationBodiesSearch',
    ]),
    addItem() {
      this.clearCertificationBodyApiError();
      this.setOpenDialog('certificationBodyAdd');
    },
    async editItem(item) {
      this.clearCertificationBodyApiError();
      this.setOpenDialog('certificationBodyEdit');
      await this.getCertificationBody(item);
      if (!this.currentCertificationBodyItem) {
        this.getCertificationBodies();
      }
    },
    async deleteItem(item) {
      this.clearCertificationBodyApiError();
      this.setOpenDialog('certificationBodyDelete');
      await this.getCertificationBody(item);
      if (!this.currentCertificationBodyItem) {
        this.getCertificationBodies();
      }
    },
    refresh() {
      this.getCertificationBodies();
    },
    clear() {
      this.setCertificationBodiesSearch('');
    },
  },
  mounted () {
    this.setCertificationBodiesSearch('');
    this.getCertificationBodies();
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'Awarding Body Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug',
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
        },
        {
          text: 'Tags',
          align: 'start',
          value: 'tags',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setCertificationBodyPaginationOptions(this.options);
        this.getCertificationBodies();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setCertificationBodiesSearch(this.search ?? '');
        this.getCertificationBodies();
      },
    },
  },
};
</script>